'use client';

import ComposerHeaderSkeleton from '@/common/ComposerHeaderSkeleton';
import SpaNavigationSkeletonOverlay from '@/common/SpaNavigationSkeletonOverlay';
import VehicleSkeletonLayout from '@/common/VehicleSkeletonLayout';
import {
  useDismissVdpNavigation,
  useShowVdpSkeleton
} from '~/context/common/VdpNavigationContext';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';

type OwnProps = {
  mainContentId: string;
};

export default function VdpSkeletonOverlay({ mainContentId }: OwnProps) {
  const showVdpSkeleton = useShowVdpSkeleton();
  const dismissVdpNavigation = useDismissVdpNavigation();
  const showComposerTreatment = useShowComposerTreatment();

  if (!showVdpSkeleton) return null;

  return (
    <SpaNavigationSkeletonOverlay
      durationEventName="vdp-skeleton-duration"
      // The current page's header may not have composer treatment (Home never does), so render VDP's instead.
      header={
        showComposerTreatment ? (
          <ComposerHeaderSkeleton route="/vehicle" />
        ) : undefined
      }
      mainContentId={mainContentId}
      onDismiss={dismissVdpNavigation}
    >
      <VehicleSkeletonLayout />
    </SpaNavigationSkeletonOverlay>
  );
}
